import { AxiosResponse, AxiosStatic } from "axios";
import { jsonToFormUrlencoded } from "../../utils";

export interface ILoginApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface ILoginApi {
  post: (data: { identifier: string; secret: string }) => Promise<AxiosResponse>;
}

export default class LoginApi implements ILoginApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: ILoginApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public post = (data: { identifier: string; secret: string }) => {
    return this.axios.request({
      data: jsonToFormUrlencoded(data),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      method: "post",
      url: `${this.apiRoot}/mobile/signIn`,
    });
  };
}
